import React from 'react'
import { Table, SwitchInput } from 'stylist'
import UpdateUserAdminMutation from 'mutations/UpdateUserAdmin'

const UserTable = ({ users, plans }) => (
  <Table data={users}>
    <Table.Row>
      <Table.Column dataKey="firstName" label="First Name" />
      <Table.Column dataKey="lastName" label="Last Name" />
      <Table.Column dataKey="email" label="Email" />
      <Table.Column
        dataKey="admin"
        label="Admin"
        render={({ admin, id: userId }) => (
          <UpdateUserAdminMutation userId={userId}>
            {updateUserAdmin => (
              <SwitchInput
                id={userId}
                checked={admin}
                label={admin ? 'Admin' : 'User'}
                onChange={e => updateUserAdmin(e.target.checked)}
              />
            )}
          </UpdateUserAdminMutation>
        )}
      />
    </Table.Row>
  </Table>
)

export default UserTable



// WEBPACK FOOTER //
// ./src/routes/admin/components/UserTable.js